import { Permissions } from "./permissions.js";

const getUserFromLocalStorage = () => {
    try {
      const rawUser = localStorage.getItem('user');
      return rawUser ? JSON.parse(rawUser) : null;
    } catch (e) {
      console.error('Erreur de parsing user localStorage', e);
      return null;
    }
};

export const usePermissions = () => {
  const user = getUserFromLocalStorage();

  const getPermission = (permissionKey) => {
    const def = Permissions[permissionKey];
    if (!def) return null;

    const roles = def.roles || [];


    const role = user?.role?.toLowerCase();
    const isAdminDSAS = role === 'admin' && user?.admin === true;

    const allowed = roles.includes(role) || (roles.includes('admindsas') && isAdminDSAS);

    return {
      allowed,
      disabledOnly: def.disabledOnly || false
    };
  };

  return { getPermission };
};